import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { InstalledAppCard } from '../InstalledAppCard';

export const InstalledAppLinkCard = ({ description, appLink, appLogo }) => (
  <InstalledAppCard description={description} appLogo={appLogo}>
    <Button variant="contained" href={appLink} color="primary" target="_blank">
      OPEN
    </Button>
  </InstalledAppCard>
);

export default InstalledAppLinkCard;

InstalledAppLinkCard.defaultProps = {
  appLink: '/',
};

InstalledAppLinkCard.propTypes = {
  description: PropTypes.string.isRequired,
  appLink: PropTypes.string,
  appLogo: PropTypes.node.isRequired,
};
